import { URL_ICON } from '@/constants/ui'
import { Box, BoxProps } from '@mui/material'
import Image from 'next/image'
import Link from '@/features/ref/components/Link'

interface LogoV2Props {
  props?: Omit<BoxProps, 'children'>
  imageColor?: 'dark' | 'light'
}
export const LogoV2 = ({ props, imageColor = 'dark' }: LogoV2Props) => {
  const isDarkImage = imageColor === 'dark'
  return (
    <Box
      component={'span'}
      {...props}
      sx={{
        marginLeft: '8px',
        flex: '0 0 auto',
        height: { md: 64, xs: 44 },
        width: 'auto',
        position: 'relative',
        ...props?.sx,
      }}
    >
      <Link href="/">
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            transform: 'translate(-50%, -80%)',
            maxWidth: '35%',
            display: 'block',
          }}
        >
          <Image
            src={URL_ICON + (isDarkImage ? 'logo-2.png' : 'logo-4.png')}
            width={18}
            height={11}
            quality={90}
            sizes="(max-width: 768px) 50vw, 10vw"
            alt="Logo"
            style={{
              height: 'auto', // Change to 'auto'
              width: '100%', // This will now work
              transition: 'filter 0.3s ease',
            }}
            className="decor-img"
          />
        </Box>
        <Image
          src={URL_ICON + (isDarkImage ? 'logo-1.png' : 'logo-3.png')}
          width={122}
          height={64}
          quality={90}
          sizes="(max-width: 768px) 100vw, 60vw"
          alt="Logo"
          style={{
            height: '100%',
            width: 'auto',
            transition: 'filter 0.3s ease',
          }}
        />
      </Link>
    </Box>
  )
}
